"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sleepNotificationKey = void 0;
var global_1 = require("../../selectors/global");
var _kernel_container_1 = __importDefault(require("../../../container"));
var global_2 = require("../../stores/global");
var player_1 = require("../../stores/player");
var _kernel_store_types_1 = require("../../types");
var showNotification_1 = __importDefault(require("../showNotification"));
var SleepSettings_1 = __importDefault(require("../../services/SleepSettings"));
var point_1 = require("../../selectors/point");
var notifications_1 = require("../../selectors/notifications");
var notifications_2 = require("../../stores/notifications");
var checkRequiredPlayState_1 = __importDefault(require("./checkRequiredPlayState"));
exports.sleepNotificationKey = "InSleepModeNotification";
function updateSleepMode(data) {
    var action = function (dispatch, getState) {
        var logger = _kernel_container_1.default.get("LOGGING").getLogger("@kernel/updateSleepMode");
        var settings = _kernel_container_1.default.get("SETTINGS");
        var showNotification = settings.getSetting("SHOW_SLEEP_NOTIFICATION", false);
        var forceAutoplayAfterSleep = settings.getSetting("FORCE_AUTOPLAY_AFTER_SLEEP", false);
        var _a = selector(getState()), wasSleeping = _a.wasSleeping, timezone = _a.timezone, sleepNotification = _a.sleepNotification;
        dispatch((0, global_2.setSleepMode)(data.shouldSleepNow, data.start, data.end));
        if (data.shouldSleepNow && !wasSleeping && data.end) {
            logger.info("Going into sleep mode", __assign({ wasSleeping: wasSleeping }, data));
            dispatch((0, player_1.setCurrentPlayState)(_kernel_store_types_1.EPlayState.STOP));
            if (forceAutoplayAfterSleep) {
                dispatch((0, player_1.setRequiredPlayState)(_kernel_store_types_1.EPlayState.PLAY));
            }
            if (showNotification) {
                dispatch((0, showNotification_1.default)({
                    type: _kernel_store_types_1.EInAppNotificationType.INFO,
                    key: exports.sleepNotificationKey,
                    text: [
                        "\u0412\u0435\u0449\u0430\u043D\u0438\u0435 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0441\u044F c ".concat(SleepSettings_1.default.formatTimestamp(data.end, timezone)),
                    ],
                    closable: false,
                }));
            }
            dispatch((0, checkRequiredPlayState_1.default)());
        }
        else if (!data.shouldSleepNow && wasSleeping) {
            logger.info("Going out of sleep mode", __assign({ wasSleeping: wasSleeping }, data));
            if (sleepNotification) {
                dispatch((0, notifications_2.removeNotification)(sleepNotification.id));
            }
            dispatch((0, checkRequiredPlayState_1.default)());
        }
        dispatch((0, global_2.setLastSleepCheck)());
    };
    action.type = updateSleepMode.type;
    return action;
}
exports.default = updateSleepMode;
updateSleepMode.type = "updateSleepMode";
function selector(state) {
    return {
        wasSleeping: (0, global_1.selectShouldSleep)(state),
        timezone: (0, point_1.selectTimezone)(state),
        sleepNotification: (0, notifications_1.selectNotificationByKey)(state, exports.sleepNotificationKey),
    };
}
//# sourceMappingURL=updateSleepMode.js.map